export enum FastTagType {
  EBAY = "egd",
  FACEBOOK = "facebook",
  SHOPIFY = "shopify",
  WALMART = "walmart",
  GOOGLE = "google",
  SFP = "sfp",
  WISH = "wish",
}
